// extracted by mini-css-extract-plugin
module.exports =  {"container":"kgVVDQP","section":"IAYXh4w","section-title":"l7zI3Ug","sectionTitle":"l7zI3Ug","title":"EOXgXNk","menu-item":"VZIiho8","menuItem":"VZIiho8"};